import { Model } from '@/services/api/lib'

class Customer extends Model {
  resource () {
    return 'customers/v1/customers'
  }

  subscribtion () {
    // TODO: hasOne
    return this.hasMany(Subscription)
  }

  // TODO: Fix: Overridden after response
  addresses () {
    return this.hasMany(Address)
  }

  orders () {
    return this.hasMany(Order)
  }

  get fullname () {
    return `${this.firstname} ${this.lastname}`
  }

  user () {
    const url = `auth/v1/users?filter[customer_id]=${this.id}`

    return this.request({
      url,
      method: 'GET'
    })
  }

  defaults () {
    return {
      dob: '',
      email: '',
      firstname: '',
      lastname: '',
      telephone: null,
      password: '',
      password_confirmation: '',
      generate_password: false,
      require_password_change: false
    }
  }

  validations () {
    return {
      dob: 'date',
      email: 'required|email',
      firstname: 'required|string',
      lastname: 'required|string',
      password: 'string|confirmed'
    }
  }
}

class Address extends Model {
  resource () {
    return 'addresses'
  }

  updateMethod () {
    return 'PUT'
  }

  defaults () {
    return {
      given_name: '',
      family_name: '',
      country_code: '',
      administrative_area: '',
      address_line1: '',
      locality: '',
      postal_code: '',
      is_default: false,
      telephone: null
    }
  }

  validations () {
    return {
      given_name: 'required|string',
      family_name: 'required|string',
      country_code: 'required|string',
      administrative_area: 'string',
      address_line1: 'required|string',
      locality: 'required|string',
      postal_code: 'required|string'
    }
  }
}

class Subscription extends Model {
  resource () {
    return 'subscription'
  }
}

class Order extends Model {
  resource () {
    return 'orders'
  }
}

class CustomerGroup extends Model {
  resource () {
    return 'customers/v1/groups'
  }

  updateMethod () {
    return 'PUT'
  }

  defaults () {
    return {
      code: '',
      name: '',
      customer_ids: []
    }
  }

  validations () {
    return {
      code: 'string',
      name: 'required|string'
    }
  }
}

export default {
  Customer,
  Address,
  Subscription,
  CustomerGroup
}
